<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/ner_tagger_example.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("nert.request") }}</h4>
                    <p class="dec mt-10 mb-10 pre">
                        {"text": "Olaf Scholz ist Bundeskanzler der Bundesrepublik Deutschland. Franz Beckenbauer, der Kaiser, hat kein politisches Amt inne. Eine Zeit lang war er der Präsident des FC Bayern München.", "language": "german"}
                    </p>

                    <h4 class="font-weight--light">{{ $t("nert.response") }}</h4>
                    <p class="dec mt-10 pre">
                        {"recognized_named_entites": [{"text": "Olaf Scholz", "type": "PER", "start_char": 0, "end_char": 11}, {"text": "Bundesrepublik Deutschland", "type": "LOC", "start_char": 34, "end_char": 60}, {"text": "Franz Beckenbauer","type": "PER", "start_char": 62,"end_char": 79}, {"text": "FC Bayern München", "type": "ORG", "start_char": 165, "end_char": 182}]}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentThree'
}
</script>
